import axiosInstance from "../config/axios.config";

export const nurseInspectionAPI = (payload) => {
  return axiosInstance.post(`inpatient/nurse-initial-assessment/`, payload);
};
export const updateNurseInspectionAPI = (id, payload) => {
  return axiosInstance.patch(
    `inpatient/nurse-initial-assessment/${id}/`,
    payload
  );
};

export const getNurseInspectionAPI = (admisssionId) => {
  return axiosInstance.get(
    `inpatient/nurse-initial-assessment/${admisssionId}/`
  );
};
export const getNurseCommonData = (admission_id, params, date) => {
  return date
    ? axiosInstance.get(
        `inpatient/nurse-care-items/${admission_id}/?type=${params}&date=${date}`
      )
    : axiosInstance.get(
        `inpatient/nurse-care-items/${admission_id}/?type=${params}`
      );
};
export const updateNurseCommonData = (id, payload) => {
  return axiosInstance.patch(
    `inpatient/nurse-care-items/update/${id}/`,
    payload
  );
};
export const getNurseMonitoringData = (admission_id, params) => {
  return params
    ? axiosInstance.get(`inpatient/monitoring-charts/${admission_id}/${params}`)
    : axiosInstance.get(`inpatient/monitoring-charts/${admission_id}/`);
};

export const updateNurseVitalsMonitoringApi = (id, payload) => {
  return axiosInstance.patch(
    `inpatient/monitoring-charts/update/${id}/`,
    payload
  );
};
export const addVitalsMonitoringApi = (id, payload) => {
  return axiosInstance.post(`inpatient/monitoring-charts/${id}/`, payload);
};
export const getIoMonitoringData = (admission_id, params) => {
  return params
    ? axiosInstance.get(`inpatient/intake-output/${admission_id}/${params}`)
    : axiosInstance.get(`inpatient/intake-output/${admission_id}/`);
};
export const addIoMonitoringData = (id, payload) => {
  return axiosInstance.post(`inpatient/intake-output/${id}/`, payload);
};
export const updateIoMonitoringData = (admission_id, id, payload) => {
  return axiosInstance.patch(
    `inpatient/intake-output/${admission_id}/${id}/`,
    payload
  );
};
export const getNurseIpPatientApi = (params) => {
  return axiosInstance.get(`inpatient/nurse-ip-list/${params}`);
};
export const floorListApi = (params) => {
  return axiosInstance.get(`/facility/floor-list/${params}`);
};
export const nurseDailyRoutineApi = (id, payload) => {
  return axiosInstance.post(`inpatient/daily-routine-care/${id}/`, payload);
};
export const updateDailyRoutineApi = (id, payload) => {
  return axiosInstance.patch(
    `inpatient/daily-routine-care/update/${id}/`,
    payload
  );
};
export const getNurseReviewDataApi = (id) => {
  return axiosInstance.get(`inpatient/nurse-review-data/${id}/`);
};
export function processAudioVitalsApi(formData) {
  return axiosInstance.post(
    "/careservices/ai-vision/process-audio-vitals/",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
}
export function processAudioGrbsApi(formData) {
  return axiosInstance.post(
    "/careservices/ai-vision/process-audio-grbs/",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
}
export function processAudioIoMonitoringApi(formData) {
  return axiosInstance.post(
    "/careservices/ai-vision/process-audio-io-monitoring/",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
}
